export default {
  resizeEventListenerThrottle: 300, // event listener onResize will not be triggered more frequently than once per given number of miliseconds
  clickDragThreshold: 10,
};
